(ns teamoesterreich.admin-mode.user.user-card-actions
  (:require [clojure.string]
            [reagent.core :as r]
            [reagent-material-ui.components :as mui]
            [goog.date.DateTime]
            [teamoesterreich.util.log :as log]
            [reagent-material-ui.cljs-time-utils :refer [cljs-time-utils]]
            [teamoesterreich.admin-mode.actions :as a]
            [teamoesterreich.admin-mode.data.rights :as d-rights]
            [teamoesterreich.admin-mode.data.user :as s-user]
            [teamoesterreich.admin-mode.modal.are-you-sure-modal :as are-you-sure-modal]
            [teamoesterreich.admin-mode.user.organisation-assign-modal :as organisation-assign-modal]



            [reagent-material-ui.icons.edit :refer [edit]]

            ))

(defn has-edit-right []
  true)


(defn time-conv [rest-time]
  (if (= "" (str rest-time))
    nil
    (str (subs rest-time 6 8) "." (subs rest-time 4 6) "." (subs rest-time 0 4))
    ))



(defn get-it [!edit-user !st]
  (let [disabled true
        !show-assign-modal? (r/cursor !st [:show-assign-modal])
        !show-delete-confirm? (r/cursor !st [:show-delete-confirm])
        !show-unsubscribe-confirm? (r/cursor !st [:show-unsubscribe-confirm])
        !show-unsubscribe-cancel? (r/cursor !st [:show-unsubscribe-cancel])
        !show-phone-confirm? (r/cursor !st [:show-phone-confirm])
        !show-email-confirm? (r/cursor !st [:show-email-confirm])
        !show-identity-confirm? (r/cursor !st [:show-identity-confirm])
        ]
    ;(log/debug "################ actual user!! " @!edit-user)
    [mui/card {:style {:textAlign "left" :marginBottom "4px"}}
     [mui/card-header
      {:style     {:textAlign "left" :paddingBottom "4px"}
       :subheader "Administration"}]

     [(organisation-assign-modal/modal !show-assign-modal? !edit-user)]

     [are-you-sure-modal/are-you-sure-modal !show-phone-confirm?
      (str "Willst du wirklich die Mobilnummer: \"" (:user-phoneNumber @!edit-user) "\" manuell validieren?")
      "Validiert"
      (fn []
        (s-user/>user-edit-field (:user-uuid @!edit-user) {:user-hdyValid true}
                                 #(s-user/actual-user-invalidate !edit-user))
        )
      ]
     [are-you-sure-modal/are-you-sure-modal !show-email-confirm?
      (str "Willst du wirklich die Email: \"" (:user-email @!edit-user) "\" manuell validieren?")
      "Validiert"
      (fn []
        (s-user/>user-edit-field (:user-uuid @!edit-user) {:user-emailValid true}
                                 #(s-user/actual-user-invalidate !edit-user)))
      ]
     [are-you-sure-modal/are-you-sure-modal !show-identity-confirm?
      (str "Willst du wirklich die Identität von : " (:user-firstName @!edit-user) " " (:user-lastName @!edit-user) " bestätigen?")
      "Identität bestätigen"
      (fn []
        (s-user/>user-edit-field (:user-uuid @!edit-user) {:user-identityValid true}
                                 #(s-user/actual-user-invalidate !edit-user)))
      ]
     [are-you-sure-modal/are-you-sure-modal !show-unsubscribe-confirm?
      [:div
       [:p "Willst du wirklich diesem Benutzer automatisch in 7 Tagen löschen: " (:user-firstName @!edit-user) " " (:user-lastName @!edit-user) "?"]
       [:p "Der Benutzer bekommt per Email die Möglichkeit sofort zu löschen oder das Löschen zu stornieren. Nach Ablauf der Zeit wird sonst gelöscht."]
       ]
      "verzögert löschen"
      (fn []
        (s-user/>user-unsubscribe (:user-tomId @!edit-user) #(s-user/actual-user-invalidate !edit-user)))]

     [are-you-sure-modal/are-you-sure-modal !show-unsubscribe-cancel?
      [:div [:p "Willst du wirklich das automatische Löschen für: " (:user-firstName @!edit-user) " " (:user-lastName @!edit-user) " ABBRECHEN ?"]]
      "Löschen abbrechen"
      #(s-user/>user-cancel-unsubscribe (:user-tomId @!edit-user) (fn [] (s-user/actual-user-invalidate !edit-user)))]

     [(are-you-sure-modal/are-you-sure-confirm-modal !show-delete-confirm?
                                                     [:div
                                                      [:h3 "Willst du wirklich diesen Benutzer für immer löschen : " (:user-firstName @!edit-user) " " (:user-lastName @!edit-user) " ? "]
                                                      [:br]
                                                      "Eine der folgenden Voraussetzungen muss erfüllt sein, um ein TÖM zu löschen:"
                                                      [:ul
                                                       [:li "Mail mit Löschantrag von der hinterlegten Emailadresse"]
                                                       [:li "Telefonischer Löschantrag von der hinterlegten Telefonnummer"]
                                                       [:li "Persönlicher Löschantrag mit bestätigter Identität"]
                                                       ]
                                                      "Bei Unklarheiten wende dich bitte an den Support!"
                                                      [:br]
                                                      [:br]
                                                      "Bestätige durch Eingabe von `Team`!"]
                                                     "Team"
                                                     "SOFORT Löschen"
                                                     (fn []
                                                       (s-user/>user-delete (:user-uuid @!edit-user) (fn []
                                                                                                       (a/unselect-user)
                                                                                                       (a/toe-list-reload)
                                                                                                       (a/set-page :toe-list))))
                                                     )]

     [mui/card-content
      {
       }
      [mui/grid
       {:container  true
        :direction  "row"
        :justify    "space-around"
        :alignItems "flex-start"
        :spacing    0
        }


       (when (d-rights/allow-admin-for d-rights/USER_DELETE); (d-rights/is-superuser?)
         [mui/grid
          {:container false :item true
           :xl        3                                     ;medium: 960px
           :md        4                                     ;medium: 960px
           :xs        6                                     ;extra-small: 0px
           }
          [mui/button
           {:variant "outlined"
            :color   "primary"
            :onClick #(reset! !show-delete-confirm? true)
            }
           (str "sofort löschen")
           ]
          ])

       (when (d-rights/allow-admin-for d-rights/USER_DELETE)
         (if (:user-to-delete-at @!edit-user)
           [mui/grid
            {:container false :item true
             :xl        3                                   ;medium: 960px
             :md        4                                   ;medium: 960px
             :xs        6                                   ;extra-small: 0px
             }
            [mui/button
             {:variant "outlined"
              :color   "primary"
              :onClick #(reset! !show-unsubscribe-cancel? true)
              :title   ""
              }
             (str "löschen für " (time-conv (:user-to-delete-at @!edit-user)) " abbrechen")
             ]
            ]
           [mui/grid
            {:container false :item true
             :xl        3                                   ;medium: 960px
             :md        4                                   ;medium: 960px
             :xs        6                                   ;extra-small: 0px
             }
            [mui/button
             {:variant "outlined"
              :color   "primary"
              :onClick #(reset! !show-unsubscribe-confirm? true)
              :title   ""
              }
             (str "verzögert löschen")
             ]
            ]))

       (when (d-rights/allow-admin-for d-rights/USER)
         [mui/grid
          {:container false :item true
           :xl        3                                     ;medium: 960px
           :md        4                                     ;medium: 960px
           :xs        6                                     ;extra-small: 0px
           }
          [mui/button
           {:variant "outlined"
            :color   "primary"
            :onClick #(reset! !show-assign-modal? true)
            }
           (str "Dienststelle zuordnen")
           ]
          ])

       (when (and (not (:user-hdyValid @!edit-user)) (d-rights/allow-admin-for d-rights/USER))
         [mui/grid
          {:container false :item true
           :xl        3                                     ;medium: 960px
           :md        4                                     ;medium: 960px
           :xs        6                                     ;extra-small: 0px
           }
          [mui/button
           {:variant "outlined"
            :color   "secondary"
            :onClick #(reset! !show-phone-confirm? true)
            }
           (str "Mobilnummer bestätigen")
           ]
          ])
       (when (and (not (:user-emailValid @!edit-user)) (d-rights/allow-admin-for d-rights/USER))
         [mui/grid
          {:container false :item true
           :xl        3                                     ;medium: 960px
           :md        4                                     ;medium: 960px
           :xs        6                                     ;extra-small: 0px
           }
          [mui/button
           {:variant "outlined"
            :color   "secondary"
            :onClick #(reset! !show-email-confirm? true)
            }
           "Email bestätigen"
           ]
          ])
       (when (and (not (:user-identityValid @!edit-user)) (d-rights/allow-admin-for d-rights/USER))
         [mui/grid
          {:container false :item true
           :xl        3                                     ;medium: 960px
           :md        4                                     ;medium: 960px
           :xs        6                                     ;extra-small: 0px
           }
          [mui/button
           {:variant "outlined"
            :color   "secondary"
            :onClick #(reset! !show-identity-confirm? true)
            }
           "Identität bestätigen"
           ]
          ])

       ]
      ]
     [mui/card-actions

      ]
     ]))